import {Component, OnDestroy, OnInit} from '@angular/core';
import {ListBaseComponent} from '../../../shared/components/base/list-base/list-base.component';
import {SectionService} from '../../../shared/services/section.service';
import {Sections} from '../../../shared/constants/sections';
import {BankTransactionDashboardService} from '../../../shared/services/bank-transaction-dashboard.service';
import {Constants} from '../../../shared/constants/constants';
import {BankTransactionDashboardFilter} from '../../../shared/filters/bank-transaction-dashboard.filter';
import {
  BankTransactionDashboardBankAccountModelDto,
  BankTransactionDashboardModelDto
} from '../../../shared/models/bank-transaction-dashboard.model';

@Component({
  selector: 'app-bank-transaction-dashboard',
  templateUrl: './bank-transaction-dashboard.component.html',
  styleUrls: ['./bank-transaction-dashboard.component.scss']
})
export class BankTransactionDashboardComponent extends ListBaseComponent implements OnInit, OnDestroy {

  constructor(protected sectionService: SectionService, protected bankTransactionDashboardService: BankTransactionDashboardService) {
    super(sectionService, Sections.Settings);
  }

  private timerId: NodeJS.Timeout;
  public lastTimeUpdated: number;
  public isPastNoon: boolean;
  public collapsed: boolean;

  filter: BankTransactionDashboardFilter;

  private millisecondsInDay: number = 1000 * 60 * 60 * 24;

  ngOnInit(): void {
    this.filter = new BankTransactionDashboardFilter();

    super.initializeView(
      Constants.BankTransactionDashboard_List_DefaultSortField,
      Constants.BankTransactionDashboard_List_DefaultSortDirectionAscending);

    this.timerId = setInterval(() => {
      this.getCollection(Constants.DefaultPageNumber);
    }, 1000 * 60 * 5);
  }

  ngOnDestroy(): void {
    clearInterval(this.timerId);
  }

  getCollection(pageNumber: number = 1): void {
    if (pageNumber) {
      this.pageConfiguration.PageNumber = pageNumber;
    }

    this.bankTransactionDashboardService.getCollection<BankTransactionDashboardModelDto>(
      '/bank-transaction/dashboard',
      this.filter,
      (collection) => {
      this.collection = collection;

      const now = new Date();
      this.lastTimeUpdated = now.getTime();
      this.isPastNoon = now.getHours() >= 12;
    });
  }

  getBanksSummary(banks: string[]): string {
    let summary = '';

    if (banks.length > 0) {
      summary = banks[0];
      let count = banks.length;
      if (count > 1) {
        count -= 1;
        summary = summary + ' +' + count;
      }
    }

    return summary;
  }

  getDayDifference(date?: Date | string): number | null {
    if (typeof date === 'string') {
      date = new Date(date);
    }

    if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
      return null;
    }

    const today = new Date();
    const referenceDate = new Date(date);

    // Remove time precision
    today.setHours(0, 0, 0, 0);
    referenceDate.setHours(0, 0, 0, 0);

    const differenceInMs = referenceDate.getTime() - today.getTime();
    return differenceInMs / this.millisecondsInDay;
  }

  getConsentDaysIndicator(item: BankTransactionDashboardModelDto): number {
    let highestIndicator = 0;

    for (const account of item.BankAccounts) {
      const indicator = this.getAccountConsentDaysIndicator(account.ConsentDaysRemaining);
      if (indicator > highestIndicator) {
        highestIndicator = indicator;
      }
    }

    return highestIndicator;
  }

  getAccountConsentDaysIndicator(daysLeft: number): number {
    if (daysLeft === null) {
      return 0;
    }

    if (daysLeft <= 5) {
      return 2;
    }

    if (daysLeft <= 14) {
      return 1;
    }

    return 0;
  }

  areReferenceDatesOk(item: BankTransactionDashboardModelDto): boolean {
    let hasProblem = false;

    for (const account of item.BankAccounts) {
      if (!this.isReferenceDateOk(account.ReferenceDate)) {
        hasProblem = true;
      }
    }

    return !hasProblem;
  }

  isReferenceDateOk(referenceDate: Date | string | null): boolean {
    const daysLeft = this.getDayDifference(referenceDate);
    return daysLeft !== null && daysLeft > -2;
  }
}
